export default function ReadyProcurementIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.5 3.5C3.22386 3.5 3 3.72386 3 4V12C3 12.2761 3.22386 12.5 3.5 12.5H8.5V11.5H4V4.5H6.79289L7.7929 5.5H12V8.5H13V5C13 4.72386 12.7761 4.5 12.5 4.5H8.2071L7.2071 3.5H3.5ZM9.73225 11.2324L11.5 13.0001L13.9748 10.5253L13.2677 9.8181L11.5 11.5859L10.4394 10.5253L9.73225 11.2324Z"
        fill="#0E121B"
      />
    </svg>
  );
}
